<template>
  <div>
    <div class="trending-container">
      <div class="flex items-center justify-between">
        <div class="flex gap-2 items-center">
          <img src="../../assets/trending-icon.svg" class="w-4" />
          <h4>Trending</h4>
        </div>
        <button
          @click="handleViewOrders"
          class="whitebutton-gemnote button-gemnote-glass--tiny gray"
        >
          <span>Send Gift</span>
        </button>
      </div>
      <div class="trending-header">
        <p>Items in your store</p>
      </div>
      <section
        class="w-full overflow-x-auto hide-scroll"
        v-if="!loadGloabalDashboard"
      >
        <div class="trending-gifts">
          <SkeletonLoader
            class="trending-element"
            height="240px"
            width="220px"
            v-for="(item, index) in 4"
            :key="'item' + index"
            :style="{ 'margin-right': '10px' }"
          />
        </div>
      </section>
      <section v-else class="w-full overflow-x-auto hide-scroll">
        <div class="trending-gifts" v-if="trendingGiftsList.length">
          <div
            class="trending-element"
            v-for="(trendingGift, index) in trendingGiftsList"
            :key="index"
          >
            <template v-if="trendingGift.product.type === 'products'">
              <router-link
                :to="{
                  name: 'ProductDetail',
                  params: { id: trendingGift.product.id }
                }"
                class="gift-link"
              >
                <img
                  :src="trendingGift.defaultImage"
                  @error="handleBrokenImage($event)"
                />
              </router-link>
              <p
                @click="
                  $router.push({
                    name: 'ProductDetail',
                    params: { id: trendingGift.product.id }
                  })
                "
                class="name cursor-pointer"
              >
                {{ trendingGift.productName }}
              </p>
            </template>
            <template v-else-if="trendingGift.product.type === 'bundles'">
              <router-link
                :to="{
                  name: 'BundleDetail',
                  params: { id: trendingGift.product.id }
                }"
                class="gift-link"
              >
                <img
                  :src="trendingGift.defaultImage"
                  @error="handleBrokenImage($event)"
                />
              </router-link>
              <p class="name">{{ trendingGift.productName }}</p>
            </template>
            <template v-else>
              <img
                :src="trendingGift.defaultImage"
                :class="{ blur: trendingGift.showBlur }"
              />
            </template>
          </div>
        </div>
        <div v-else class="empty-trending-gifts">
          <p>No items to display</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus, handleBrokenImage } from '../../helpers'
import SkeletonLoader from '@/components/Universal/Skeleton'
export default {
  name: 'TrendingGifts',
  components: {
    SkeletonLoader
  },

  data: () => ({
    handleBrokenImage: handleBrokenImage
  }),

  computed: {
    loadGloabalDashboard() {
      return progressStatus(this.loadBarChart)
    },
    loadLocalChat() {
      return progressStatus(this.loadingTrendingGifts)
    },
    ...mapState({
      loadingTrendingGifts: state => state.report.loadingTrendingGifts,
      loadBarChart: state => state.report.loadBarChart,
      trendingGiftsList: state => state.report.trendingGiftsList
    })
  },

  created() {
    this.$store.dispatch('report/trendingGifts')
  },
  methods: {
    handleViewOrders() {
      this.$router.push('/gifts')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.whitebutton-gemnote--small {
  font-size: 0.813rem;
  font-weight: normal;
  height: 2.5rem;
  width: max-content !important;
  padding: 0 0rem !important;
}

.button-gemnote-glass--tiny {
  width: max-content !important;
  font-weight: 400 !important;
  padding: 0 1rem !important;
}

.trending-container {
  padding: 1rem;
  border: 1px solid $main-6;
  border-radius: 2px;
  margin-bottom: 1rem;
}

.trending-header {
  margin: 1rem 0;
  p {
    text-align: left;
    font-size: 0.813rem;
  }
}

.trending-gifts {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent items from wrapping */
  scroll-behavior: smooth; /* Smooth scrolling */
  padding-bottom: 0.5rem; /* Prevent scrollbar overlap */
}

/* Scrollbar styles */
.trending-gifts {
  scrollbar-width: thin; /* Firefox thin scrollbar */
  scrollbar-color: #888 #f0f0f0; /* Thumb and track colors */
}

.trending-gifts::-webkit-scrollbar {
  height: 8px; /* Horizontal scrollbar height */
}

.trending-gifts::-webkit-scrollbar-track {
  background: #f0f0f0; /* Track background */
}

.trending-gifts::-webkit-scrollbar-thumb {
  background: #888; /* Thumb color */
  border-radius: 4px; /* Rounded corners for thumb */
}

.trending-gifts::-webkit-scrollbar-thumb:hover {
  background: #555; /* Darker thumb color on hover */
}

.trending-element {
  width: 220px;
  height: 240px;
  text-align: left;
  border: 0.5px solid #a09c95;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  a {
    display: block;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & img {
    width: 100%;
    max-width: 170px;
    max-height: 170px;
    object-fit: contain;
    margin: 0 auto;
  }

  .name {
    border-top: 0.5px solid #a09c95;
    width: 100%;
    padding: 0.5rem 0;
    padding-left: 0.75rem;
    padding-right: 0.5rem;
    font-size: 0.813rem;
    color: #232220;
    height: 2rem; /* Ensure consistent height */
    display: block;
    white-space: nowrap; /* Prevent text wrapping */
    overflow: hidden; /* Hide overflowing text */
    text-overflow: ellipsis; /* Add the ellipsis */
  }
}

.blur {
  opacity: 0.2;
}

.trending-button {
  flex-basis: 10%;
  text-align: right;
}

h4 {
  font-family: $editorial;
  font-weight: normal;
}

.empty-trending-gifts {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 0.813rem;
    color: #232220;
  }
}
@media (max-width: 900px) {
  .trending-header {
    h4 {
      text-align: center;
    }
  }

  .trending-gifts {
    row-gap: 1rem;
  }
}

@media (max-width: 575.98px) {
  .trending-button {
    width: 100%;
  }
  .full-btn {
    width: inherit;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .trending-button {
    width: 100%;
  }
  .full-btn {
    width: inherit;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .trending-button {
    width: 100%;
  }
  .full-btn {
    width: inherit;
  }
}

.hide-scroll {
  scrollbar-width: none;
}
</style>
